/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';

const IconLink = (props) => (
  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width={props.size} height={props.size} viewBox="0 0 23 23">
    <path stroke={props.strokeColor} strokeWidth="1" strokeMiterlimit="10" fill="none" d="M 21.31,6.79 L 17.2,10.89 C 15.96,12.14 13.86,12.14 12.52,10.8 L 12.33,10.61 C 10.99,9.27 10.99,7.17 12.23,5.93 L 16.44,1.92 C 17.68,0.68 19.78,0.68 21.12,2.01 L 21.31,2.21 C 22.55,3.45 22.55,5.55 21.31,6.79 Z M 21.31,6.79" />
    <path stroke={props.strokeColor} strokeWidth="1" strokeMiterlimit="10" fill="none" d="M 10.99,17.1 L 6.89,21.21 C 5.64,22.45 3.54,22.45 2.21,21.11 L 2.02,20.92 C 0.68,19.58 0.68,17.48 1.92,16.24 L 6.03,12.14 C 7.27,10.89 9.37,10.89 10.71,12.23 L 10.9,12.42 C 12.23,13.76 12.33,15.86 10.99,17.1 Z M 10.99,17.1" />
    <path stroke={props.strokeColor} strokeWidth="1" strokeLinecap="round" strokeMiterlimit="10" fill="none" d="M 8.89,14.33 L 14.62,8.6" />
</svg>
);
IconLink.propTypes = {
  strokeColor: PropTypes.string,
  size: PropTypes.string,
};
IconLink.defaultProps = {
  strokeColor: '#111111',
  size: '24',
};

export default IconLink;
